import { fromJS, merge } from 'immutable';
import { FluxStandardAction } from '__utils/type';
import * as Actions from 'constants/actions'

export interface nfoState {
    nfoAppliedFilterList: Array<any>;
    nfoAppliedSortItem: string;
}
const rawState: nfoState = {
    nfoAppliedFilterList: [],
    nfoAppliedSortItem: ""
};

const intialState = fromJS(rawState);

export default function nfoReducer(
    state = intialState,
    action: FluxStandardAction
) {
    switch (action.type) {
        case Actions.SET_NFO_APPLIED_FILTER_LIST:
            return merge(state, fromJS({ nfoAppliedFilterList: action.payload }));
        case Actions.SET_NFO_APPLIED_SORT_LIST:
            return merge(state, fromJS({ nfoAppliedSortItem: action.payload }));
        default:
            return state;
    }
}
